import React, { useContext, useState } from 'react'
import { MessageThreadModel } from '../../models/MessageCenterModels';
import MessageForm from './MessageForm';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { BankUserContext } from '../../bankUserContext';
import { messageCenterConfig } from '../../config/MessageCenterConfig';
import Avatar from 'react-avatar';
import { getMessageThreadUserName } from '../../utils/GeneralUtils';

interface IMessageFormModalProps {
  config?: any
  messagesModal: boolean;
  toogleMessagesModal: () => void;
  conversation: MessageThreadModel;
  setConversation: React.Dispatch<React.SetStateAction<MessageThreadModel | undefined>>;
}

const MessageFormModal = (props: IMessageFormModalProps) => {
  const { config, messagesModal, toogleMessagesModal, conversation, setConversation } = props;
  const { bankuserDetails } = useContext(BankUserContext);

  return (
    <Modal
      className="messages-modal"
      isOpen={messagesModal}
      fade={false}
      toggle={toogleMessagesModal}
    >
    <ModalHeader toggle={toogleMessagesModal}>
      <div className="message-header">
        <div className="message-avatar">
          <Avatar 
            name={(conversation.clientName || "").trim() || ((conversation.userDisplayFirstName || "").trim()+ " "+(conversation.userDisplayLastName || "").trim())} 
            size="30" 
            round={true} 
          />
        </div>
        <div className="details">
          <div className="name-subject">
            <div className="name">
              {getMessageThreadUserName(conversation)}
            </div>
            <div className="subject mb-1">
              <span className="subject-label">Subject: </span>
              {conversation?.subject || '--'}
            </div>
          </div>
        </div>
      </div>
      
    </ModalHeader>
    <ModalBody>
      <MessageForm
        config={config || messageCenterConfig}
        conversation={conversation}
        setConversation={setConversation}
        bankuserDetails={bankuserDetails}  
      />
    </ModalBody>
  </Modal>
  )
}

export default MessageFormModal